import MUIBox from '@/components/MUI-Components/MUI-Box';
import MUIGrid from '@/components/MUI-Components/MUI-Grid';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
import React, {memo} from 'react';
import DisplayImage from '../display-image';
import parse from 'html-react-parser';
import Link from 'next/link';
import {spacing, fontSize, borderRadius} from '@/styles/tokens';

// font-family intentionally omitted: MUI-Typography already applies
// theme.typography.fontFamily ('RegularText') as its defaultSx on every
// instance, so re-declaring it here would be dead weight.
const sxServiceWrapper = {
    justifyContent: 'center',
    paddingTop: spacing[24]
};

const sxServiceSubheading = {
    fontSize: fontSize[16],
    paddingTop: '14px' // no exact spacing-token match at 14px
};

// text-align matches the removed @media (max-width:600px) override — MUI's
// default `sm` breakpoint is 600px, matching this repo's convention. Padding
// is unchanged at that breakpoint (16px both above and below it).
const sxServiceItemWrapper = {
    textAlign: 'center',
    padding: spacing[16],
    height: '100%'
};

const sxServiceCardImage = {
    borderRadius: borderRadius.circle,
    width: spacing[80],
    height: spacing[80],
    padding: spacing[16],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#e0eaff', // no exact token match (closest is colors.primary.iconBg #e0e8ff)
    margin: 'auto',
    border: '1px dashed rgb(39, 39, 39)', // no exact token match
    marginBottom: spacing[12],
    '& img': {
        width: '100%',
        height: '100%'
    }
};

const sxHeadingLink = {
    textDecoration: 'none',
    '&:hover': {
        textDecoration: 'underline'
    }
};

const TransportService = (props: any) => {
    const {heading, subheading, service, className} = props;

    return (
        <>
            <MUIBox className="spectrum-header-wrapper">
                <MUITypography className="spectrum-heading color-black">{heading}</MUITypography>
                <MUIBox className="divder-wrapper">
                    <hr className="divider-line" />
                </MUIBox>
                {subheading && (
                    <MUIBox className="sub-heading-box" pb={1}>
                        <MUITypography className="spectrum-sub-heading color-black text-padding data_links">
                            {subheading ? parse(subheading) : ''}
                        </MUITypography>
                    </MUIBox>
                )}
            </MUIBox>
            <MUIGrid container sx={sxServiceWrapper} spacing={3}>
                {service?.map((data: any, index: number) => (
                    <MUIGrid key={index + 1} item md={4} sm={6} xs={12} className={className} sx={sxServiceItemWrapper}>
                        <MUIBox component="span" sx={sxServiceCardImage}>
                            <DisplayImage src={data.icon} alt={data.heading} priority={false} />
                        </MUIBox>
                        {data?.redirect && data?.redirect !== '' ? (
                            <MUIBox
                                component={Link}
                                className="one-step-content-heading center"
                                href={data.redirect}
                                target="_blank"
                                sx={sxHeadingLink}
                            >
                                {data.heading}
                            </MUIBox>
                        ) : (
                            <MUITypography className="one-step-content-heading center">{data.heading}</MUITypography>
                        )}

                        <MUITypography className="center data_links" sx={sxServiceSubheading}>
                            {data.body ? parse(data.body) : ''}
                        </MUITypography>
                    </MUIGrid>
                ))}
            </MUIGrid>
        </>
    );
};

export default memo(TransportService);
